import { useState } from 'react';
import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/mangaData';

const footerLinks = {
  '热门漫画': [
    { label: '健身教练', path: '/manga/1/chapter/248' },
    { label: '斗破苍穹', path: '/manga/2/chapter/623' },
    { label: '一人之下', path: '/manga/5/chapter/512' },
    { label: '非人哉', path: '/manga/7/chapter/420' },
  ],
  '漫画分类': [
    { label: '热血动作', path: '/category/action' },
    { label: '恋爱言情', path: '/category/romance' },
    { label: '搞笑日常', path: '/category/comedy' },
    { label: '玄幻奇幻', path: '/category/fantasy' },
  ],
  '平台服务': [
    { label: '关于我们', path: '/about' },
    { label: '商务合作', path: '/about#contact' },
    { label: '用户协议', path: '/about' },
    { label: '隐私政策', path: '/about' },
  ],
  '帮助支持': [
    { label: '常见问题', path: '/about#faq' },
    { label: '阅读指南', path: '/about' },
    { label: '反馈建议', path: '/about#contact' },
    { label: '投诉举报', path: '/about#contact' },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeMsg, setSubscribeMsg] = useState('');
  const [subscribing, setSubscribing] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    const honeypot = (e.currentTarget as HTMLFormElement).querySelector<HTMLInputElement>('input[name="company_alt"]');
    if (honeypot && honeypot.value.trim()) {
      setSubscribeMsg('订阅成功！感谢您的关注。');
      setEmail('');
      return;
    }

    setSubscribing(true);
    try {
      const formData = new FormData(e.currentTarget as HTMLFormElement);
      formData.delete('company_alt');
      const res = await fetch('http://chigua52.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      if (res.ok && (parsed as { code?: string }).code === 'OK') {
        setSubscribeMsg('订阅成功！我们会将最新漫画资讯发送到您的邮箱。');
        setEmail('');
      } else {
        const errMsg = (parsed as { meta?: { message?: string } })?.meta?.message || '订阅失败，请稍后再试。';
        setSubscribeMsg(errMsg);
      }
    } catch {
      setSubscribeMsg('网络异常，请稍后重试。');
    } finally {
      setSubscribing(false);
    }
  };

  return (
    <footer className="bg-secondary-900 text-white">
      <div className="mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-10">
          <div className="lg:w-1/3">
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-accent-500 rounded-lg">
                <i className="ri-book-open-line text-white text-base"></i>
              </div>
              <span className="text-xl font-bold font-heading">4399漫画</span>
            </Link>
            <p className="text-secondary-200 text-sm leading-relaxed mb-5">
              {siteInfo.siteDescription}
            </p>
            <form
              onSubmit={handleSubscribe}
              className="flex items-center gap-0"
            >
              <input
                type="text"
                name="company_alt"
                className="form-anti-spam"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="输入邮箱订阅更新"
                className="bg-white/10 border border-white/20 rounded-l-full px-4 py-2.5 text-sm text-white placeholder-white/40 outline-none w-full max-w-[260px] focus:border-accent-400 transition-colors"
              />
              <button
                type="submit"
                disabled={subscribing}
                className="bg-accent-500 hover:bg-accent-600 text-white rounded-r-full px-4 py-2.5 flex items-center justify-center transition-colors cursor-pointer disabled:opacity-50 whitespace-nowrap"
              >
                <i className="ri-notification-3-line text-base"></i>
              </button>
            </form>
            {subscribeMsg && (
              <p className="text-xs text-accent-300 mt-2">{subscribeMsg}</p>
            )}
            <p className="text-xl text-white/80 mt-5 font-heading leading-relaxed">
              下拉式阅读，让漫画更自由
            </p>
          </div>

          <div className="lg:w-2/3 grid grid-cols-2 sm:grid-cols-4 gap-6">
            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="text-white text-sm font-semibold mb-3">{title}</h4>
                <div className="flex flex-col gap-2">
                  {links.map((link) => (
                    <Link
                      key={link.label}
                      to={link.path}
                      className="text-secondary-200 hover:text-white text-sm transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 mt-8 border-t border-white/10 gap-4">
          <p className="text-xs text-secondary-300 whitespace-nowrap">
            &copy; {new Date().getFullYear()} 4399漫画网 版权所有
          </p>
          <div className="flex items-center gap-3">
            {['ri-wechat-line', 'ri-links-line', 'ri-movie-line', 'ri-share-forward-line'].map((icon) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                target="_blank"
                className="w-8 h-8 flex items-center justify-center border border-white/20 rounded-lg text-white/60 hover:text-white hover:border-white/40 transition-colors cursor-pointer"
                aria-label="社交媒体"
              >
                <i className={`${icon} text-sm`}></i>
              </a>
            ))}
          </div>
          <a href="/about" className="text-xs text-secondary-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
            隐私政策
          </a>
        </div>
      </div>
    </footer>
  );
}